import { muiTheme as theme } from '@tassat/payments-themes';

export const muiStyles = () => ({
    fullWidth: {
        width: '100%',
        alignSelf: 'center' as 'center'
    },
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    submitButton: { width: 'auto' as 'auto' },
    submitButtonContainer: {
        marginTop: '2.5rem',
        marginBottom: '2rem'
    },
    submitError: { alignSelf: 'center' },
    ssoUserIdInfo: {
        position: 'relative' as 'relative',
        top: '-15px'
    },
    infoText: {
        lineHeight: '32px',
        paddingLeft: '15px',
        fontSize: '13px'
    },
    infoIcon: {
        width: '30px',
        height: '30px'
    },
    checkboxField: {
        '& label': {
            width: '35px',
            alignItems: 'flex-start',
            minHeight: '1rem'
        },
        '& span': {
            border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#CFCFCF'}`,
            borderRadius: '3px'
        },
        marginRight: '1.2rem'
    },
    cancelButton: { width: '200px' }
});